import UploadProgressBar from 'app/components/UploadProgressBar';

const MomentUploadProgressBar = props => {
  const {
    moment
  } = props;

  let fileId = moment.id;

  return <UploadProgressBar {...{ fileId }} />;
}

export default MomentUploadProgressBar;
